export interface ContactLink {
  href: string;
  label: string;
}

export interface ContactSector {
  slug: string;
  name: string;
  emails: ContactLink[];
  whatsapps: ContactLink[];
  phones: string[];
}

function email(address: string): ContactLink {
  return { href: `mailto:${address}`, label: address };
}

function whatsapp(label: string, digits: string): ContactLink {
  return { href: `https://api.whatsapp.com/send?phone=${digits}`, label };
}

export const contactSectors: ContactSector[] = [
  {
    slug: "gabinete",
    name: "Gabinete do Procurador Geral",
    emails: [email("gabinete.pgm@pgm.fortaleza.ce.gov.br")],
    whatsapps: [whatsapp("(85) 3265-1613", "558532651613")],
    phones: [],
  },
  {
    slug: "judiciario",
    name: "Judiciário e Ministério Público",
    emails: [email("intimacoesurgentes@pgm.fortaleza.ce.gov.br")],
    whatsapps: [],
    phones: [],
  },
  {
    slug: "fazenda-publica",
    name: "Procuradoria da Fazenda Pública (Dívida Ativa)",
    emails: [email("atendimento.da@pgm.fortaleza.ce.gov.br")],
    whatsapps: [],
    phones: ["(85) 98419-2045", "(85) 98419-2042"],
  },
  {
    slug: "judicial",
    name: "Procuradoria Judicial",
    emails: [email("projud@pgm.fortaleza.ce.gov.br")],
    whatsapps: [whatsapp("(85) 8563-2536", "558585632536")],
    phones: [],
  },
  {
    slug: "urbanismo",
    name: "Procuradoria de Urbanismo e Meio Ambiente",
    emails: [email("pgm.prourma@pgm.fortaleza.ce.gov.br")],
    whatsapps: [whatsapp("(85) 98400-7795", "5585984007795")],
    phones: ["(85) 2018-0198"],
  },
  {
    slug: "propad",
    name: "Procuradoria do Processo Administrativo Disciplinar",
    emails: [email("propad.jp@pgm.fortaleza.ce.gov.br")],
    whatsapps: [whatsapp("(85) 98682-2972", "5585986822972")],
    phones: [],
  },
  {
    slug: "consultoria-geral",
    name: "Consultoria Geral",
    emails: [email("conger@pgm.fortaleza.ce.gov.br")],
    whatsapps: [whatsapp("(85) 99191-5931", "5585991915931")],
    phones: ["(85) 2018-0154"],
  },
  {
    slug: "biblioteca",
    name: "Procuradoria de Desenvolvimento e Pesquisa/Biblioteca",
    emails: [email("biblioteca.pgm@pgm.fortaleza.ce.gov.br")],
    whatsapps: [whatsapp("(85) 98408-3976", "5585984083976")],
    phones: [],
  },
  {
    slug: "protocolo",
    name: "Protocolo",
    emails: [email("protocolo.pgm@pgm.fortaleza.ce.gov.br")],
    whatsapps: [],
    phones: ["(85) 2018-0153"],
  },
  {
    slug: "administracao-indireta",
    name: "Procuradoria da Administração Indireta",
    emails: [email("procadin@pgm.fortaleza.ce.gov.br")],
    whatsapps: [],
    phones: [],
  },
  {
    slug: "prolic",
    name: "Procuradoria de Licitações, Contratos Administrativos e Controle Externo",
    emails: [email("prolic@pgm.fortaleza.ce.gov.br")],
    whatsapps: [],
    phones: [],
  },
];
